import {createElement} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../../redux';
import {setRuntimeMenuState, toggleRuntimeMenuState} from '../../../../../redux/actions/runtime/menu';
import {menuStateSelector} from '../../../../../redux/selectors/runtime/menu';
import {Props} from './model';
import View from './view';

export const DropdownMenu = (props: Props) => {
  const isActive = useSelector(menuStateSelector());
  const dispatch = useAppDispatch();
  return createElement(View, {
    ...props,
    isActive,
    onClick: () => {
      dispatch(toggleRuntimeMenuState());
    },
    close: () => {
      dispatch(setRuntimeMenuState(false));
    },
  });
};
